import withModal from '../modal/withModal';
import UserAddressForm from './UserAddressForm';
import { USER_ADDRESS_MODAL } from '../../../constants/modals';

export default withModal(UserAddressForm, {
  name: USER_ADDRESS_MODAL,
  size: 'sm',
  hideHeader: true,
  dismissible: false,
  overlayClassName: 'z-modal-max',
});
